import { render, staticRenderFns } from "./note_edited_text.vue?vue&type=template&id=3d5944c0&"
import script from "./note_edited_text.vue?vue&type=script&lang=js&"
export * from "./note_edited_text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "note_edited_text.vue"
export default component.exports